<script>

	import ProgressBar from "../../../../ui/ProgressBar.svelte";

	import { spotlight } from '../../../../lib/stores.js';

	export let poll;
	export let results;
	export let studioBanner = false;

	let totalVotes = 0;
	let percentages = {};
	let winners = {};

	function calcVotes() {
		let total = 0;
		Object.values(results).forEach(v => {
			total += v;
		});
		totalVotes = total;
	}

	function calcPercentages() {
		let p = {};
		Object.values(poll.options).forEach(opt => {
			p[opt.value] = getPercentage(results[opt.value]);
		});
		percentages = p;
	}

	function getPercentage(votes) {
		if (!votes) return 0;
		return Number(((votes / totalVotes) * 100).toFixed(1));
	}

	function calcWinners() {
		let maxValue = 0;
		const values = Object.keys(percentages);
		values.map(p => {
			maxValue = Math.max(maxValue, percentages[p]);
		});
		Object.keys(percentages).forEach(p => {
			if (percentages[p] == maxValue) {
				winners[p] = true;
			}
		});
		// console.log({maxValue},{winners});
	}

	$: if (results) {
		calcVotes();
		calcPercentages();
		calcWinners();
	}

</script>

<style>
	.question {
		font-size: 0.9em;
		margin-bottom: 0.75em;
		color: var(--textColor);
	}
	.option {
		margin: 0.5em 0;
		border: 1px solid var(--blend-20);
		padding: 0.5em;
		border-radius: 4px;
		background: var(--bgColor);
	}
	.option p {
		margin: 0;
		font-size: 0.9em;
	}
	.banner .option p {
		font-size: 1em;
	}
	.option .label {
		display: flex;
		justify-content: space-between;
		gap: 1em;
		color: var(--textColor);
	}
	.votes {
		color: var(--blend-60);
	}
</style>

<div class="results" class:banner={studioBanner} style="--c:{poll.options.length}">
	<p class="question"><strong>{poll.question}</strong></p>
	<div class="options">
		{#each poll.options as opt, i (opt.value)}
			<div class="option" class:winner={winners[opt.value]}>
				<p class="label">
					<strong class="labeltext">{opt.label}</strong>
					<strong class="percentage">{percentages[opt.value]}<span>%</span></strong>
				</p>
				{#if !studioBanner}
					<ProgressBar amount={results[opt.value]} total={totalVotes} delay={$spotlight ? 600 : 0}/>
					<p class="votes">
						{#if results[opt.value]}
							{#if results[opt.value] == 1}
								1 vote
							{:else}
								{results[opt.value]} votes
							{/if}
						{:else}
							0 votes
						{/if}
					</p>
				{/if}
			</div>
		{/each}
	</div>
</div>
